module.exports = __webpack_public_path__ + "img/hero.b91012e7.png";